import { IconButton, Menu, MenuItem, MenuList } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import OnHoldModal from '../modals/OnHoldModal'
import DeleteModal from '../modals/DeleteModal'
import ResetModal from '@reader_task_list_view/components/ResetModal'

export default function PopupMenuList({ task_id, study_id }: { task_id: string; study_id: string }) {
  return (
    <PopupState variant="popover">
      {(popupState) => (
        <Fragment>
          <IconButton
            {...bindTrigger(popupState)}
            onClick={(e) => {
              popupState.open(e)
              e.stopPropagation()
            }}
          >
            <MoreVertRoundedIcon fontSize="small" data-testid="popup-menu-icon" />
          </IconButton>
          <Menu
            {...bindMenu(popupState)}
            onClick={(e) => e.stopPropagation()}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            data-testid="popup-menu-list"
          >
            <MenuList
              sx={{
                width: 188,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingY: 0.5,
                outline: 'none',
              }}
            >
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reopen"
              >
                <OnHoldModal taskIds={[task_id]} study_id={study_id} popupState={popupState} />
              </MenuItem>
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reset"
              >
                <ResetModal read_task_id={task_id} read_pseudo_id={0} study_id={study_id} popupState={popupState} />
              </MenuItem>
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reset"
              >
                <DeleteModal taskIds={[task_id]} study_id={study_id} popupState={popupState} />
              </MenuItem>
            </MenuList>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  )
}
